import { NavLink } from 'react-router-dom';
import { useUiStore } from '@/stores/ui';
import styles from './HeaderNavItem.module.css';

interface HeaderNavItemProps {
  to: string;
  label: string;
  end?: boolean;
  /** 'inline' (default) — horizontal item. 'mobile' — full-width row in drawer. */
  variant?: 'inline' | 'mobile';
}

export function HeaderNavItem({ to, label, end, variant = 'inline' }: HeaderNavItemProps) {
  const setMobileMenuOpen = useUiStore((s) => s.setSidebarOpen);

  return (
    <NavLink
      to={to}
      end={end}
      onClick={() => setMobileMenuOpen(false)}
      className={({ isActive }) =>
        [
          variant === 'mobile' ? styles.itemMobile : styles.itemInline,
          isActive ? styles.itemActive : '',
        ]
          .filter(Boolean)
          .join(' ')
      }
    >
      <span className={styles.label}>{label}</span>
    </NavLink>
  );
}
